import React, {useEffect, useState} from "react";
import ReactModal from "react-modal";

import "./Modal.scss";

function Modal({children, ...props}) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(props.show);
    }, [props.show]);

    const handleCloseModal = () => {
        props?.onClose && props.onClose(false);
        setShow(false);
    }

    const renderChildren = () => React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            const childProps = {
                closeModal: handleCloseModal,
                onSubmit: props.onSubmit
            };
            return React.cloneElement(child, childProps);
        }
        return child;
    });

    return (
        <ReactModal
            appElement={document.getElementById('root')}
            bodyOpenClassName="ReactModal__Body--open CustomModal"
            isOpen={show}
            onRequestClose={handleCloseModal}
            shouldCloseOnOverlayClick={true}
            portalClassName={`ReactModalPortal ${props.htmlOpenClassName}`}
        >

            <div className="modal-header">
                {props.customTitle ? props.customTitle : <h5 className="modal-title">{props.title}</h5>}
                <button onClick={handleCloseModal} type="button" className="close" data-dismiss="modal"
                        aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>

            {renderChildren()}

        </ReactModal>
    );
}

export default Modal;